module.exports = __webpack_public_path__ + "img/bg_chess_02.9aa63881.jpg";